import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class SocialSecurityQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.SOCIAL_SECURITY;
  useKey: boolean;

  constructor(options: any = {}) {
    super(options);
    this.useKey = options['useKey'] || false;
  }
}
